import { useNavigate } from 'react-router-dom';

import { IconCheck, IllustrationTaskComplete } from '@snorose/icons';

import { Button } from '@/shared/component';

import styles from './SignUpSuccessPage.module.css';

export default function SignUpSuccessPage() {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div>
        <IconCheck
          width={24}
          height={24}
          className={styles.icon}
          color='var(--blue-4)'
        />
        <p className={styles.title}>스노로즈 가입이 완료되었어요!</p>
        <p className={styles.explanation}>
          별도의 인증 절차 후<br />
          스노로즈 전체 서비스를 이용하실 수 있어요
        </p>
      </div>
      <div className={styles.img}>
        <IllustrationTaskComplete
          className={styles.illustration}
          role='img'
          aria-label='회원가입 성공을 알리는 일러스트'
        />
      </div>

      <div>
        <div className={styles.submit}>
          <Button
            btnName='로그인하기'
            className={'right'}
            onClick={() => navigate('/login')}
          />
        </div>
      </div>
    </div>
  );
}
